// ============================================================================
// Avec → Feel King — Dicionário de aliases de serviços
// ============================================================================
// Cada serviço do Feel King tem uma lista de aliases que podem aparecer no
// Avec (mesmo serviço cadastrado com nomes diferentes em cada unidade).
//
// Foi construído empiricamente a partir dos dados reais das 5 unidades
// (Moema, Vila Olímpia, Itaim Bibi, Oscar Freire, Jardins) em março/2026.
//
// Para adicionar novo alias: coloca o nome exato (como aparece na Avec) no
// array do serviço correspondente. A comparação é case/acento-insensitive.
// ============================================================================

export const SERVICE_ALIASES = {
  // ── Cortes ───────────────────────────────────────────────────────────────
  'svc-corte': [
    'Corte',
    'Corte de Cabelo',
    'Corte à Máquina',
    'Corte á máquina',
    'Corte Máquina',
    'Corte assinatura',
  ],
  'svc-corte-barba-completa': [
    'Corte e Barba',
    'Corte de Cabelo e Barba',
    'Corte de Cabelo Barba completa',
    'Corte de Cabelo  Barba completa', // dois espaços (sic)
    'Corte e barba assinatura',
    'Corte Barba',
    'Corte Barba Completa',
  ],
  'svc-corte-visagista': ['Corte Visagista'],
  'svc-corte-barba-visagista': [
    'Corte e barba Visagista',
    'Corte e Barba Visagista',
    'Corte e barba visagista',
    'Corte Barba Visagista',
  ],

  // ── Barbas ───────────────────────────────────────────────────────────────
  'svc-barba-completa': [
    'Barba',
    'Barba Completa',
    'Barba completa',
    'Barba assinatura',
  ],
  'svc-barba-visagista': ['Barba Visagista', 'Barba visagista'],
  'svc-consultoria-visagista': [
    'Consultoria Visagista',
    'Consultoria visagista',
    'Consultoria de Visagismo',
  ],
  'svc-barboterapia': ['Barboterapia'],

  // ── Tratamentos de cabelo ────────────────────────────────────────────────
  'svc-hidratacao': ['Hidratação', 'Hidratacao'],
  'svc-botox': ['Botox Capilar', 'Botox'],
  'svc-lavagem-especial': [
    'Lavagem Especial',
    'Lavagem especial',
    'Lavagem especial 10 min',
    'Lavagem',
  ],
  'svc-mascara-argila': ['Máscara de Argila', 'Máscara de argila', 'Mascara de Argila'],
  'svc-disfarce': [
    'Disfarce de grisalhos barba',
    'Disfarce de grisalhos Barba',
    'Disfarce de grisalho Barba',
    'Disfarce de grisalhos (barba Keune)',
    'Disfarce de grisalhos barba (keune)',
    'Disfarce de grisalhos Cabelo',
    'Disfarce de grisalhos de Cabelo',
    'Disfarce Grisalho Cabelo',
    'Disfarce de grisalho cabelo (keune)',
    'Disfarce de grisalhos (cabelo keune)',
  ],

  // ── Sobrancelha (todas variações) ───────────────────────────────────────
  'svc-sobrancelha': [
    'Sobrancelha',
    'Aparar Sobrancelha',
    'Aparar Sobrancelhas',
    'Sobrancelha cera',
    'Sobrancelha Cera',
    'Sobrancelha na Cera',
    'Sobrancelha na cera',
    'Sobrancelha Lamina',
    'Sobrancelha Lâmina',
  ],

  // ── Acabamento (pézinho = acabamento, confirmado) ────────────────────────
  'svc-acabamento': [
    'Pézinho',
    'Pezinho',
    'Acabamento Cabelo',
    'Acabamento de Cabelo',
    'Acabamento de cabelo',
    'Acabamento',
  ],

  // ── Depilação nariz/orelha ──────────────────────────────────────────────
  'svc-depilacao': [
    'Depilação',
    'Depilação Nariz',
    'Depilação de Nariz',
    'Depilação Orelha',
    'Depilação de Orelha',
    'Depilação Orelha e Nariz',
    'Depilação Orelha  Nariz', // dois espaços
    'Depilação de Nariz e Orelha',
    'Depilação nariz e orelha',
    'Depilção Nariz e Orelha', // typo "Depilção"
    'Depilação nariz ou orelha',
    'Depillação Nariz', // typo "Depillação"
  ],

  // ── Combos e pacotes especiais ──────────────────────────────────────────
  'svc-combo-black': ['Combo Black'],

  // ── Facial/Estética ─────────────────────────────────────────────────────
  'svc-terapia-facial': ['Terapia facial', 'Terapia Facial'],
  'svc-limpeza-pele': ['Limpeza de Pele Profunda', 'Limpeza de pele profunda', 'Limpeza de Pele'],
  'svc-peeling-facial': ['Peeling', 'Peeling Facial'],
  'svc-anti-idade': ['Tratamento Anti Idade', 'Anti Idade'],
  'svc-anti-acne': ['Tratamento Anti Acne', 'Anti Acne'],
  'svc-revitalizacao-facial': ['Revitalização Facial', 'Revitalizacao Facial'],

  // ── Manicure e pedicure ─────────────────────────────────────────────────
  'svc-manicure-pedicure': [
    'Manicure',
    'Pedicure',
    'Manicure e Pedicure',
    'Manicure e pedicure',
  ],
  'svc-spa-pes': ['Spa para os Pés', 'Spa dos Pés', 'Spa dos pes'],
  'svc-hidratacao-pes': ['Hidratação dos pés', 'Hidratacao dos pes', 'Hidratação nos Pés'],
  'svc-massagem-pes': ['Massagem nos pés', 'Massagem nos Pés'],
  'svc-reflexologia': ['Reflexologia'],

  // ── Massagens ───────────────────────────────────────────────────────────
  'svc-massagem-cranio-facial': ['Massagem Crânio Facial', 'Massagem cranio facial'],
  'svc-massagem-dorsal': ['Massagem Dorsal'],
  'svc-massagem-dorsal-40': ['Massagem Dorsal 40min', 'Massagem Dorsal 40 min'],
  'svc-massagem-relaxante-30': ['Massagem Relaxante 30min', 'Massagem Relaxante 30 min'],
  'svc-massagem-relaxante-60': ['Massagem Relaxante 60min', 'Massagem Relaxante 60 min'],
  'svc-massagem-terapeutica-30': ['Massagem Terapêutica 30min', 'Massagem Terapêutica 30 min'],
  'svc-massagem-terapeutica-60': ['Massagem Terapêutica 60min', 'Massagem Terapêutica 60 min'],
  'svc-drenagem-linfatica': ['Drenagem Linfática', 'Drenagem Linfática 50min', 'Drenagem linfatica'],
  'svc-ventosa': ['Ventosa'],

  // ── Laser ───────────────────────────────────────────────────────────────
  'svc-laser-abdomen': ['Laser - Abdômen', 'Laser Abdomen'],
  'svc-laser-axila': ['Laser - Axila', 'Laser Axila'],
  'svc-laser-barba-completa': ['Laser - Barba Completa', 'Laser Barba'],
  'svc-laser-bracos': ['Laser - Braços Completos', 'Laser Bracos'],
  'svc-laser-contorno-barba': ['Laser - Contorno de Barba', 'Laser Contorno'],
  'svc-laser-costas': ['Laser - Costas'],
  'svc-laser-nuca': ['Laser - Nuca'],
  'svc-laser-ombros': ['Laser - Ombros'],
  'svc-laser-peito': ['Laser - Peito'],
  'svc-laser-pernas': ['Laser - Pernas Inteiras', 'Laser Pernas'],
};

// Serviços sem match no FK (aparecem na Avec mas não temos equivalente no nosso catálogo)
// Podem ser adicionados futuramente ou ficam "sem categoria"
export const UNMATCHED_AVEC_SERVICES = [
  'Consultoria Visagista',
  'Consultoria visagista',
];
